module.exports = __webpack_public_path__ + "static/media/br-go.16988048.svg";